"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = require("../constants/theme");
const utils_1 = require("../utils");
const create_styles_1 = require("../utils/create-styles");
const styled_system_1 = require("../utils/styled-system");
const PARAGRAPH_FONT_SIZES = {
    small: {
        mobile: theme_1.theme.font.size[6],
        desktop: theme_1.theme.font.size[6],
    },
    medium: {
        mobile: theme_1.theme.font.size[5.5],
        desktop: theme_1.theme.font.size[5],
    },
    large: {
        mobile: theme_1.theme.font.size[5],
        desktop: theme_1.theme.font.size[4],
    },
    larger: {
        mobile: theme_1.theme.font.size[4],
        desktop: theme_1.theme.font.size[3],
    },
};
exports.Paragraph = styled_1.default.p((props) => {
    const fontSizes = PARAGRAPH_FONT_SIZES[props.size ?? 'medium'];
    return {
        color: props.color,
        ...(0, styled_system_1.fontSize)({ fontSize: fontSizes.mobile }),
        fontWeight: props.bold ? theme_1.theme.font.weight.bold : undefined,
        // TODO(rb): change lineHeight to 1.4:
        lineHeight: 1.5,
        marginBottom: props.noMargin ? 0 : 24,
        marginTop: 0,
        maxWidth: 752,
        opacity: props.disabled ? 0.4 : props.subtle ? 0.6 : 0.8,
        ...(0, styled_system_1.space)(props),
        [(0, utils_1.mediaBreakpointGte)('md')]: {
            ...(0, styled_system_1.fontSize)({ fontSize: fontSizes.desktop }),
        },
        ...(0, create_styles_1.createStyles)(props.styles),
    };
});
